import type { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { CardProps } from 'components/Card';
import Typography from '../Typography';
import {
  ForSaleContainer,
  StyledPrice,
  StyledTrTitle,
  StyledTrDescribe,
  StyledNoListings,
  StyledDescriptionContainer,
  SideText,
  SideTextCapitalized,
  SideTextLight,
  SideTextSmall,
  SideTextBlock,
} from './styled';

const TrimmedCardText: FC<{
  card: CardProps,
  isCollectedCollection?: boolean,
  listing?: boolean,
  listingsCount?: number,
  hideListing?: boolean,
  price?: number,
}> = ({
  card,
  isCollectedCollection,
  listing,
  listingsCount = 0,
  hideListing = false,
  price = 0,
}) => {
  const { t } = useTranslation();

  const {
    title,
    rarity,
    forSale = false,
    totalEditions,
    edition,
    editions,
    staked: isStaked,
  } = card || {};

  let collectedCardText: ReactElement | null = null;
  if (isCollectedCollection) {
    if (forSale) {
      if (listing) {
        collectedCardText = (
          <SideTextBlock>
            <SideTextSmall>
              <SideTextSmall>
                <Typography size="captionSmall">Lowest Price</Typography>
              </SideTextSmall>
            </SideTextSmall>
            <StyledPrice>
              <SideText>
                $
                {price.toFixed(2)}
              </SideText>
            </StyledPrice>
          </SideTextBlock>
        );
      } else {
        collectedCardText = (
          <div>
            <ForSaleContainer>
              {t('card.forSale')}
            </ForSaleContainer>
            <StyledPrice>
              $
              {price.toFixed(2)}
            </StyledPrice>
          </div>
        );
      }
    } else {
      collectedCardText = (
        <SideTextLight>
          {t('card.notForSale')}
        </SideTextLight>
      );
    }
    if (isStaked) {
      collectedCardText = (
        <SideTextLight>
          Staked
        </SideTextLight>
      );
    }
  }

  return (
    <StyledDescriptionContainer>
      <StyledTrTitle>
        <SideText>{title}</SideText>
      </StyledTrTitle>
      <StyledTrDescribe>
        <SideTextCapitalized>{(rarity || '').replace('_', ' ')}</SideTextCapitalized>
        <SideText>
          <span>
            {`#${edition || ''}`}
          </span>
          /
          <span>
            {totalEditions || editions}
          </span>
        </SideText>
        {
          isCollectedCollection ? collectedCardText : (
            <>
              {listing
                ? (
                  <SideTextBlock>
                    <SideTextSmall>
                      <SideTextSmall>
                        <Typography size="captionSmall">{t('card.lowestAsk')}</Typography>
                      </SideTextSmall>
                    </SideTextSmall>
                    <StyledPrice>
                      <SideText>
                        $
                        {price.toFixed(2)}
                      </SideText>
                    </StyledPrice>
                    <SideTextSmall textColor="#666666">
                      {t('card.listings', { amount: listingsCount })}
                    </SideTextSmall>
                  </SideTextBlock>
                ) : (
                  !hideListing && (
                    <StyledNoListings as="div">
                      <SideTextLight>{t('card.noListings')}</SideTextLight>
                    </StyledNoListings>
                  )
                )}
            </>
          )
        }
      </StyledTrDescribe>
    </StyledDescriptionContainer>
  );
};

export default TrimmedCardText;
